<template>
    <div>
        <v-card class="pa-2">
            <canvas id="chart4" ref="chart4" height="184" ></canvas>
        </v-card>
    </div>
</template>

<script>
import Chart from 'chart.js';

export default {
    data() {
        return {
            chart: null,
            canvas: null,
            loading: true,
            data: [],
            labels: []
        }
    },
    watch: {
        chartData() {
            this.render();
        }
    },
    props: {
        chartData: Array
    },
    mounted() {
        this.render();
    },
    methods: {
        render() {
            if(this.chart && this.canvas) {
                this.chart.destroy();
                this.canvas = null;
            }

            this.labels = Object.keys(this.chartData[0]);
            this.data = Object.values(this.chartData[0]);

            this.canvas = this.$refs['chart4'].getContext('2d');

            this.chart = new Chart(this.canvas, {
                type: 'doughnut',
                data: {
                    datasets: [{
                        data: this.data,
                        backgroundColor: ["#0D47A1", "#1565C0", "#1976D2", "#1E88E5", "#42A5F5", "#64B5F6", "#90CAF9", "#BBDEFB", "#E3F2FD", "#2196F3", "#82B1FF", "#448AFF", "#2979FF", "#2962FF"]
                    }],
                    labels: this.labels,
                    
                },
                options: {
                    title: {
                        display: true,
                        text: 'Transactions By Amount',
                        fontSize: 12,
                        fontStyle: 400,
                        // fontColor: '#000'
                    },
                }
            })
        }
    }
}
</script>

<style>

</style>